"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Builder = _interopRequireDefault(require("./Builder.js"));

var _ImageBuilder = _interopRequireDefault(require("./ImageBuilder.js"));

var _LineStringBuilder = _interopRequireDefault(require("./LineStringBuilder.js"));

var _PolygonBuilder = _interopRequireDefault(require("./PolygonBuilder.js"));

var _TextBuilder = _interopRequireDefault(require("./TextBuilder.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @module ol/render/canvas/BuilderGroup
 */

/**
 * @type {Object<import("./BuilderType").default, typeof Builder>}
 */
var BATCH_CONSTRUCTORS = {
  'Circle': _PolygonBuilder["default"],
  'Default': _Builder["default"],
  'Image': _ImageBuilder["default"],
  'LineString': _LineStringBuilder["default"],
  'Polygon': _PolygonBuilder["default"],
  'Text': _TextBuilder["default"]
};

var BuilderGroup =
/** @class */
function () {
  /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Max extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */
  function BuilderGroup(tolerance, maxExtent, resolution, pixelRatio) {
    /**
     * @private
     * @type {number}
     */
    this.tolerance_ = tolerance;
    /**
     * @private
     * @type {import("../../extent.js").Extent}
     */

    this.maxExtent_ = maxExtent;
    /**
     * @private
     * @type {number}
     */

    this.pixelRatio_ = pixelRatio;
    /**
     * @private
     * @type {number}
     */

    this.resolution_ = resolution;
    /**
     * @private
     * @type {!Object<string, !Object<import("./BuilderType").default, Builder>>}
     */

    this.buildersByZIndex_ = {};
  }
  /**
   * @return {!Object<string, !Object<import("./BuilderType").default, import("./Builder.js").SerializableInstructions>>} The serializable instructions
   */


  BuilderGroup.prototype.finish = function () {
    var builderInstructions = {};

    for (var zKey in this.buildersByZIndex_) {
      builderInstructions[zKey] = builderInstructions[zKey] || {};
      var builders = this.buildersByZIndex_[zKey];

      for (var builderKey in builders) {
        var builderInstruction = builders[builderKey].finish();
        builderInstructions[zKey][builderKey] = builderInstruction;
      }
    }

    return builderInstructions;
  };
  /**
   * @param {number|undefined} zIndex Z index.
   * @param {import("./BuilderType.js").default} builderType Replay type.
   * @return {import("../VectorContext.js").default} Replay.
   */


  BuilderGroup.prototype.getBuilder = function (zIndex, builderType) {
    var zIndexKey = zIndex !== undefined ? zIndex.toString() : '0';
    var replays = this.buildersByZIndex_[zIndexKey];

    if (replays === undefined) {
      replays = {};
      this.buildersByZIndex_[zIndexKey] = replays;
    }

    var replay = replays[builderType];

    if (replay === undefined) {
      var Constructor = BATCH_CONSTRUCTORS[builderType];
      replay = new Constructor(this.tolerance_, this.maxExtent_, this.resolution_, this.pixelRatio_);
      replays[builderType] = replay;
    }

    return replay;
  };

  return BuilderGroup;
}();

var _default = BuilderGroup;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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